/**
 * Error de la API del portal, con el status y el código de negocio a mano.
 *
 * Existe porque el interceptor de `api/client.ts` rechaza con un `Error`
 * plano: la respuesta de axios se perdía, y el código que hacía
 * `err.response.status === 409` para detectar la ventana de 24 h cerrada nunca
 * entraba en esa rama — el asesor veía "No se pudo enviar el mensaje" en vez de
 * la explicación y el botón de plantilla.
 *
 * `code` es el campo `error` del body (`outside_window`, `templates_disabled`,
 * `no_asignada`, …), que es lo que distingue un caso de negocio de una caída.
 */
export class ApiError extends Error {
  readonly status: number
  readonly code: string

  constructor(message: string, status: number, code = '') {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.code = code
  }
}

export function isApiError(err: unknown): err is ApiError {
  return err instanceof ApiError
}

/** Código de negocio del error, o cadena vacía si no es un ApiError. */
export function errorCode(err: unknown): string {
  return isApiError(err) ? err.code : ''
}

export function errorMessage(err: unknown, fallback: string): string {
  if (err instanceof Error && err.message) return err.message
  return fallback
}
